/**
 * Vendor Waitlist Service
 * Handles vendor waitlist applications to unified multi-city API
 */

// @ts-ignore - Vite env vars
const API_BASE_URL = import.meta.env?.VITE_API_BASE_URL || 'https://api.toolboxlogic.com';

export interface VendorWaitlistData {
  businessName: string;
  contactName: string;
  jobTitle?: string;
  email: string;
  phone: string;
  website?: string;
  serviceCategory: string;
  serviceDescription: string;
  yearsInBusiness?: string;
  preferredPlan?: string;
  hasInsurance?: boolean;
  hasLicense?: boolean;
  willingToKyc?: boolean;
  agreeToTerms?: boolean;
  additionalInfo?: string;
}

export interface VendorWaitlistResponse {
  success: boolean;
  error?: string;
  data?: {
    id: string;
    market_key: string;
    created_at: string;
  };
}

export async function submitVendorWaitlist(
  formData: VendorWaitlistData,
): Promise<VendorWaitlistResponse> {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/louisiana/lake-charles/vendor-waitlist`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    const result = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: result.message || `Server error: ${response.status}`,
      };
    }

    return {
      success: true,
      data: result.data,
    };
  } catch (error) {
    console.error('Vendor waitlist submission error:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Network error occurred',
    };
  }
}
